/*
Replace
producer with your resource Name :) Take care about different writings!
/!\ Producer producer Producers producers /!\
Keep an eye on pluralized namings in here :)

*/

import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultShow,
  defaultShowFail,
  defaultShowSuccess,
  defaultUpdate,
  defaultUpdateSuccess,
  defaultUpdateFail,
  defaultCreate,
  defaultCreateSuccess,
  defaultCreateFail,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const producerSlice = createSlice({
  name: "producers",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    show: defaultShow,
    showSuccess: defaultShowSuccess,
    showFail: defaultShowFail,
    create: defaultCreate,
    createSuccess: defaultCreateSuccess,
    createFail: defaultCreateFail,
    update: defaultUpdate,
    updateSuccess: defaultUpdateSuccess,
    updateFail: defaultUpdateFail,
    addToDictionary: defaultAddToDictionary,
  },
});

export const {
  list: listProducers,
  show: showProducer,
  create: createProducer,
  update: updateProducer,
} = producerSlice.actions;

export const actions = producerSlice.actions;
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const producers = (state) =>
  state.producers.idsList.map((id) => state.producers.dictionary[id]);
export const producer = (state) =>
  state.producers.showId && state.producers.dictionary[state.producers.showId];
export const producerAttributes = (state) => producer(state)?.attributes;
export const producerRelationships = (state) => producer(state)?.relationships;
export const producerId = (state) => state.producers.showId;

export const getProducer = createSelector(
  (state) => state.producers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getProducerAttributes = createSelector(
  (state) => state.producers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getProducerRelationships = createSelector(
  (state) => state.producers.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getProducers = createSelector(
  (state) => state.producers.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export default producerSlice.reducer;
